module.exports = __webpack_public_path__ + "img/placeholder-user.8fe588f0.png";